import React from "react";
import "./toggle.css";

const ToggleSwitch = ({ data, name, checked, handleStatusToggle }) => {


  return (
    <div className="toggle-switch">
      <input
        type="checkbox"
        id={`toggleSwitch-${data?.id}-${name}`}
        checked={checked || false}
      />
      <label
        htmlFor={`toggleSwitch-${data?.id}-${name}`}
        className="switch-label"
      >
        <span className="switch-inner" />
        <span className="switch-handle" />
      </label>
    </div>
  );
};

export default ToggleSwitch;